// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1f4fc30a","885":"2da7f33b"}[chunkId] + ".chunk.js";
};